// extracted by mini-css-extract-plugin
module.exports = {"h3":"Databases_h3__bbko5","h2":"Databases_h2__nM9fu","hr":"Databases_hr__gMsKX","university":"Databases_university__X2cn2","databases":"Databases_databases__um0Hl"};